import { routeName } from '@/constants/routeName';
import WorkerMonthlyAttendance from '@/views/WorkerMonthlyAttendance/index.vue';
import basicOptions from '@/router/basic-options';
export default [
    {
        path: 'worker-monthly-attendance',
        name: routeName.WORKER_MONTHLY_ATTENDANCE,
        component: WorkerMonthlyAttendance,
        meta: {
            ...basicOptions,
        },
    },
];
